(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accelerate-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('accelerate-shop')) {
    customElements.define('accelerate-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.catalog = this.querySelector('.acc-shop__catalog');
        this.status = this.querySelector('.acc-shop__status');
        const select = (index, focus = false) => {
          tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index;});
          if (focus) tabs[index].focus();
          const link = panels[index].querySelector('[aria-current="true"]') || panels[index].querySelector('.acc-shop__categories a');
          if (link) this.choose(link);
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(index));
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) {event.preventDefault(); select(next, true);}
          });
        });
        this.addEventListener('click', event => {
          const link = event.target.closest('.acc-shop__categories a, .acc-catalog__pagination a, [data-acc-filter-link]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          if (link.closest('.acc-shop__categories')) this.choose(link);
          else this.load(link.href, true);
        });
        this.addEventListener('change', event => {
          const form = event.target.closest('.acc-catalog__form');
          if (form) this.submitFilters(form);
        });
        this.addEventListener('submit', event => {
          if (!event.target.matches('.acc-catalog__form')) return;
          event.preventDefault();
          this.submitFilters(event.target);
        });
        select(0);
        this.addEventListener('shopify:block:select', event => {const index = panels.findIndex(panel => panel.contains(event.target)); if (index >= 0) select(index);});
      }
      choose(link) {
        link.closest('nav').querySelectorAll('a').forEach(item => item.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
        this.label = this.querySelector('[role="tab"][aria-selected="true"] strong').textContent + ' – ' + link.textContent;
        this.load(link.href);
      }
      submitFilters(form) {
        const url = new URL(this.currentUrl);
        url.search = new URLSearchParams(new FormData(form)).toString();
        this.load(url.href);
      }
      async load(href, scroll = false) {
        const url = new URL(href, location.origin);
        if (url.origin !== location.origin) return;
        this.abort?.abort();
        this.abort = new AbortController();
        this.catalog.setAttribute('aria-busy', 'true');
        this.status.textContent = this.status.dataset.loading;
        url.searchParams.delete('page');
        const original = new URL(href, location.origin);
        if (original.searchParams.has('page')) url.searchParams.set('page', original.searchParams.get('page'));
        url.searchParams.delete('section_id');
        this.currentUrl = url.href;
        url.searchParams.set('section_id', 'accelerate-catalog');
        try {
          const response = await fetch(url, {signal: this.abort.signal});
          if (!response.ok) throw new Error('catalog');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('[data-acc-catalog]');
          if (!content) throw new Error('catalog');
          this.catalog.replaceChildren(content);
          const heading = content.querySelector('[data-acc-heading]');
          if (heading) heading.textContent = this.label;
          this.status.textContent = '';
          this.catalog.setAttribute('aria-busy', 'false');
          if (scroll) this.catalog.scrollIntoView({block:'start'});
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.catalog.replaceChildren();
          this.status.textContent = this.status.dataset.error;
          const retry = document.createElement('a');
          retry.href = this.currentUrl;
          retry.textContent = this.label;
          this.catalog.append(retry);
          this.catalog.setAttribute('aria-busy', 'false');
        }
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customized-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customized-shop')) {
    customElements.define('customized-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.catalog = this.querySelector('.acc-shop__catalog');
        this.status = this.querySelector('.acc-shop__status');
        const select = (index, focus = false) => {
          tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index;});
          if (focus) tabs[index].focus();
          const link = panels[index].querySelector('[aria-current="true"]') || panels[index].querySelector('.acc-shop__categories a');
          if (link) this.choose(link);
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(index));
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) {event.preventDefault(); select(next, true);}
          });
        });
        this.addEventListener('click', event => {
          const link = event.target.closest('.acc-shop__categories a, .acc-catalog__pagination a, [data-acc-filter-link]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          if (link.closest('.acc-shop__categories')) this.choose(link);
          else this.load(link.href, true);
        });
        this.addEventListener('change', event => {
          const form = event.target.closest('.acc-catalog__form');
          if (form) this.submitFilters(form);
        });
        this.addEventListener('submit', event => {
          if (!event.target.matches('.acc-catalog__form')) return;
          event.preventDefault();
          this.submitFilters(event.target);
        });
        select(0);
        this.addEventListener('shopify:block:select', event => {const index = panels.findIndex(panel => panel.contains(event.target)); if (index >= 0) select(index);});
      }
      choose(link) {
        link.closest('nav').querySelectorAll('a').forEach(item => item.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
        this.label = this.querySelector('[role="tab"][aria-selected="true"] strong').textContent + ' – ' + link.textContent;
        this.load(link.href);
      }
      submitFilters(form) {
        const url = new URL(this.currentUrl);
        url.search = new URLSearchParams(new FormData(form)).toString();
        this.load(url.href);
      }
      async load(href, scroll = false) {
        const url = new URL(href, location.origin);
        if (url.origin !== location.origin) return;
        this.abort?.abort();
        this.abort = new AbortController();
        this.catalog.setAttribute('aria-busy', 'true');
        this.status.textContent = this.status.dataset.loading;
        url.searchParams.delete('page');
        const original = new URL(href, location.origin);
        if (original.searchParams.has('page')) url.searchParams.set('page', original.searchParams.get('page'));
        url.searchParams.delete('section_id');
        this.currentUrl = url.href;
        url.searchParams.set('section_id', 'accelerate-catalog');
        try {
          const response = await fetch(url, {signal: this.abort.signal});
          if (!response.ok) throw new Error('catalog');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('[data-acc-catalog]');
          if (!content) throw new Error('catalog');
          this.catalog.replaceChildren(content);
          const heading = content.querySelector('[data-acc-heading]');
          if (heading) heading.textContent = this.label;
          this.status.textContent = '';
          this.catalog.setAttribute('aria-busy', 'false');
          if (scroll) this.catalog.scrollIntoView({block:'start'});
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.catalog.replaceChildren();
          this.status.textContent = this.status.dataset.error;
          const retry = document.createElement('a');
          retry.href = this.currentUrl;
          retry.textContent = this.label;
          this.catalog.append(retry);
          this.catalog.setAttribute('aria-busy', 'false');
        }
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('series-shop')) {
    customElements.define('series-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.catalog = this.querySelector('.acc-shop__catalog');
        this.status = this.querySelector('.acc-shop__status');
        const select = (index, focus = false) => {
          tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index;});
          if (focus) tabs[index].focus();
          const link = panels[index].querySelector('[aria-current="true"]') || panels[index].querySelector('.acc-shop__categories a');
          if (link) this.choose(link);
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(index));
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) {event.preventDefault(); select(next, true);}
          });
        });
        this.addEventListener('click', event => {
          const link = event.target.closest('.acc-shop__categories a, .acc-catalog__pagination a, [data-acc-filter-link]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          if (link.closest('.acc-shop__categories')) this.choose(link);
          else this.load(link.href, true);
        });
        this.addEventListener('change', event => {
          const form = event.target.closest('.acc-catalog__form');
          if (form) this.submitFilters(form);
        });
        this.addEventListener('submit', event => {
          if (!event.target.matches('.acc-catalog__form')) return;
          event.preventDefault();
          this.submitFilters(event.target);
        });
        select(0);
        this.addEventListener('shopify:block:select', event => {const index = panels.findIndex(panel => panel.contains(event.target)); if (index >= 0) select(index);});
      }
      choose(link) {
        link.closest('nav').querySelectorAll('a').forEach(item => item.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
        this.label = this.querySelector('[role="tab"][aria-selected="true"] strong').textContent + ' – ' + link.textContent;
        this.load(link.href);
      }
      submitFilters(form) {
        const url = new URL(this.currentUrl);
        url.search = new URLSearchParams(new FormData(form)).toString();
        this.load(url.href);
      }
      async load(href, scroll = false) {
        const url = new URL(href, location.origin);
        if (url.origin !== location.origin) return;
        this.abort?.abort();
        this.abort = new AbortController();
        this.catalog.setAttribute('aria-busy', 'true');
        this.status.textContent = this.status.dataset.loading;
        url.searchParams.delete('page');
        const original = new URL(href, location.origin);
        if (original.searchParams.has('page')) url.searchParams.set('page', original.searchParams.get('page'));
        url.searchParams.delete('section_id');
        this.currentUrl = url.href;
        url.searchParams.set('section_id', 'accelerate-catalog');
        try {
          const response = await fetch(url, {signal: this.abort.signal});
          if (!response.ok) throw new Error('catalog');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('[data-acc-catalog]');
          if (!content) throw new Error('catalog');
          this.catalog.replaceChildren(content);
          const heading = content.querySelector('[data-acc-heading]');
          if (heading) heading.textContent = this.label;
          this.status.textContent = '';
          this.catalog.setAttribute('aria-busy', 'false');
          if (scroll) this.catalog.scrollIntoView({block:'start'});
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.catalog.replaceChildren();
          this.status.textContent = this.status.dataset.error;
          const retry = document.createElement('a');
          retry.href = this.currentUrl;
          retry.textContent = this.label;
          this.catalog.append(retry);
          this.catalog.setAttribute('aria-busy', 'false');
        }
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
